import { DaysOfWeekEnum } from "@sweatpals/shared";

export const DaysOfWeek: { [key: number]: { id: DaysOfWeekEnum; abbr: string } } = {
	0: {
		id: DaysOfWeekEnum.Sunday,
		abbr: 'S',
	},
	1: {
		id: DaysOfWeekEnum.Monday,
		abbr: 'M',
	},
	2: {
		id: DaysOfWeekEnum.Tuesday,
		abbr: 'T',
	},
	3: {
		id: DaysOfWeekEnum.Wednesday,
		abbr: 'W',
	},
	4: {
		id: DaysOfWeekEnum.Thursday,
		abbr: 'T',
	},
	5: {
		id: DaysOfWeekEnum.Friday,
		abbr: 'F',
	},
	6: {
		id: DaysOfWeekEnum.Saturday,
		abbr: 'S',
	},
};

export const DaysOfWeekArray = Array.from({ ...DaysOfWeek, length: 7 }) as Array<{ id: DaysOfWeekEnum; abbr: string }>;

export const DaysOfWeekAbbr = {
	[DaysOfWeekEnum.Sunday]: 'Sun',
	[DaysOfWeekEnum.Monday]: 'Mon',
	[DaysOfWeekEnum.Tuesday]: 'Tues',
	[DaysOfWeekEnum.Wednesday]: 'Wed',
	[DaysOfWeekEnum.Thursday]: 'Thurs',
	[DaysOfWeekEnum.Friday]: 'Fri',
	[DaysOfWeekEnum.Saturday]: 'Sat',
};

export const minWeekInterval = 1;
export const maxWeekInterval = 4;
